import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import BulkDrawer from '../BulkDrawer';
import translations from './translations';

const BulkProductDrawer = ({ title, columns, ...props }) => {
  const intl = useIntl();

  return (
    <BulkDrawer
      columns={[
        intl.formatMessage(translations.columns.sku),
        intl.formatMessage(translations.columns.quantity),
      ]}
      title={title ?? intl.formatMessage(translations.title)}
      {...props}
    />
  );
};

BulkProductDrawer.propTypes = BulkDrawer.propTypes;

BulkProductDrawer.defaultProps = BulkDrawer.defaultProps;

export default BulkProductDrawer;
